import React from "react";
import { VisuallyHidden } from "../../atoms/VisuallyHidden";
import { ActionLink, Bar, Body, Card, Content, Dismiss, Footer, IconBadge, Title } from "./Toast.styles";
import { DismissIcon, ToastGlyph } from "./ToastGlyph";
import type { ToastProps } from "./Toast.types";

/** A notification card (prototype `.nt-toast`): what happened, what to do next, and a way to close it. */
export const Toast: React.FC<ToastProps> = ({
  id,
  kind,
  title,
  body,
  kindLabel,
  icon = null,
  progress = null,
  actionLabel = null,
  onAction,
  secondaryActionLabel = null,
  onSecondaryAction,
  appearance = "default",
  radius,
  dismissLabel,
  onDismiss,
  className,
}) => (
  <Card className={className} $kind={kind} $appearance={appearance} $radius={radius} data-appearance={appearance} data-kind={kind} data-toast-id={id}>
    <IconBadge $kind={kind} $appearance={appearance} aria-hidden="true">
      <ToastGlyph kind={kind} icon={icon} />
    </IconBadge>
    <Content $appearance={appearance}>
      <Title $appearance={appearance}>
        {kindLabel ? <VisuallyHidden>{`${kindLabel}: `}</VisuallyHidden> : null}
        {title}
      </Title>
      {body ? <Body $appearance={appearance}>{body}</Body> : null}
      {progress !== null ? <Bar value={progress} size="sm" ariaLabel={title} /> : null}
      {actionLabel && onAction ? (
        <Footer $appearance={appearance}>
          <ActionLink type="button" $appearance={appearance} onClick={onAction}>
            {actionLabel}
          </ActionLink>
          {secondaryActionLabel && onSecondaryAction ? (
            <ActionLink type="button" $appearance={appearance} $emphasis onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </ActionLink>
          ) : null}
        </Footer>
      ) : null}
    </Content>
    <Dismiss $appearance={appearance} icon={DismissIcon} aria-label={dismissLabel} onClick={onDismiss} size="md" />
  </Card>
);

export default Toast;
